import { render, staticRenderFns } from "./multi-select.vue?vue&type=template&id=6d871c90&scoped=true"
import script from "./multi-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./multi-select.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./multi-select.vue?vue&type=style&index=0&id=6d871c90&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d871c90",
  null
  
)

export default component.exports